import { InputHTMLAttributes, memo, forwardRef } from 'react';
import './Input.css';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    helperText?: string;
}

/**
 * Input Component
 * Reusable input field with label and error handling
 */
export const Input = memo(
    forwardRef<HTMLInputElement, InputProps>(
        ({ label, error, helperText, className = '', id, ...props }, ref) => {
            const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

            return (
                <div className="input-wrapper">
                    {label && (
                        <label htmlFor={inputId} className="input-label">
                            {label}
                        </label>
                    )}
                    <input
                        ref={ref}
                        id={inputId}
                        className={`input ${error ? 'input--error' : ''} ${className}`}
                        aria-invalid={!!error}
                        aria-describedby={error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined}
                        {...props}
                    />
                    {error && (
                        <span id={`${inputId}-error`} className="input-error">
                            {error}
                        </span>
                    )}
                    {helperText && !error && (
                        <span id={`${inputId}-helper`} className="input-helper">
                            {helperText}
                        </span>
                    )}
                </div>
            );
        }
    )
);

Input.displayName = 'Input';
